export default __webpack_public_path__ + "static/media/mitigation-open-wall-work-area.2f79fc63.jpg";